module.exports = __webpack_public_path__ + "img/cpu_usage.620ce4f0.png";